import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  author: string;
  age?: string;
  delay?: number;
}
export function TestimonialCard({
  quote,
  author,
  age,
  delay = 0
}: TestimonialCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.6,
    delay
  }} className="bg-gray-50 p-6 rounded-lg border-l-4 border-[#7C3AED] my-8 shadow-sm" data-id="element-261">
      <div className="flex gap-1 mb-3 text-yellow-400" data-id="element-262">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-263" />)}
      </div>
      <blockquote className="text-gray-700 italic mb-4 text-lg" data-id="element-264">
        "{quote}"
      </blockquote>
      <div className="font-semibold text-gray-900" data-id="element-265">
        — {author}
        {age && <span className="text-gray-500 font-normal" data-id="element-266">, {age}</span>}
      </div>
    </motion.div>;
}